import type { CreditActionsResponse } from '@/api';

export const selectWithdrawAction = (creditActions: CreditActionsResponse) => creditActions.withdraw;

export const selectIsTierMigrationNeeded = ({ withdraw }: CreditActionsResponse) =>
  withdraw.disabled && withdraw.reasons.includes('MigrationToNewTierNeeded');
